import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('NewsPeriodicity')
export class NewsPeriodicity {

  @JsonProperty('type', Number)
  type: number = 0;

  @JsonProperty('days_mask', Any)
  daysMask: number | null = null;

  @JsonProperty('day_start', Any)
  dayStart: number | null = null;

  @JsonProperty('day_end', Any)
  dayEnd: number | null = null;

  @JsonProperty('time_start', String)
  timeStart: string = '';

  @JsonProperty('time_end', String)
  timeEnd: string = '';
}
